import Player from 'components/Audio';
import ImageCustom from 'components/ImageCustom';
import * as React from 'react';
export default {
  Player,
  ImageCustom,
  React
};